import { MarkupRule } from 'app/components/common/FormattedText/types';
import { Set } from 'immutable';
import { markupParser, textRenderer } from 'app/components/common/FormattedText/parser';

/**
 * Can be used to remove markdown rules from text.
 *
 * @param ruleSet - Rules to be removed.
 */
export const stripMarkup = (source: string, ruleSet: Set<MarkupRule>): string => {
  const state = { inline: true, ruleSet };

  // Because the state is mutable, clone it.
  const ast = markupParser(source, { ...state });
  return textRenderer(ast, { ...state });
};

/**
 * Markup rules allowed in title content.
 */
const titleRuleSet: Set<MarkupRule> = Set([
  MarkupRule.Italic,
  MarkupRule.Ruby,
]);

/**
 * Removes markup from titles, which support markup for italics and ruby text.
 */
export const stripTitleMarkup = (source?: string): string => {
  return stripMarkup(source ?? '', titleRuleSet);
};

/**
 * Markup rules allowed in sentences.
 */
const sentenceContentRuleSet: Set<MarkupRule> = Set([
  MarkupRule.Bold,
  MarkupRule.Italic,
  MarkupRule.Ruby,
]);

/**
 * Helper for pulling bold markup out of the lesson material.
 */
export const stripSentenceContentMarkup = (source?: string): string => {
  return stripMarkup(source ?? '', sentenceContentRuleSet);
};
